import { useEffect, useState } from 'react'

import { ICommonScanCriteria } from '../../../interfaces/scan_criterias';

import ResultAccordion from './ResultAccordion';
import ResultCard from './ResultNavigationCard';

interface IResultContainerProps {
    scanCriterias: ICommonScanCriteria[];
}

const ResultContainer = (props: IResultContainerProps) => {
    const { scanCriterias } = props;

    const [currentScanCriteriaIndex, setCurrentScanCriteriaIndex] = useState<number>(0);

    useEffect(() => {
        setCurrentScanCriteriaIndex(0);
    }, [scanCriterias]);

    const onHandleTabClick = (index: number) => {
        setCurrentScanCriteriaIndex(index);
    }

    // Use window.location.href instead of location.href
    const maxCriteriaLevel = window.location.href.includes('interviews') ? 3 : 4;

    return (
        <div className='immersion__result__container'>
            <div className='immersion__result__container__content'>
                <ResultAccordion
                    maxLevel={maxCriteriaLevel}
                    scanCriteria={scanCriterias[currentScanCriteriaIndex]}
                />
            </div>
            <div className='immersion__result__container__navigation'>
                {scanCriterias.map((scanCriteria, index) => {
                    return (
                        <ResultCard
                            key={index}
                            active={currentScanCriteriaIndex === index}
                            level={scanCriteria.level}
                            maxLevel={maxCriteriaLevel}
                            title={scanCriteria.title}
                            subtitle={scanCriteria.description}
                            onHandleTabChange={() => onHandleTabClick(index)}
                        />
                    )
                })}
            </div>
        </div>
    )
}

export default ResultContainer
